import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=a4a6a4d8&"
import script from "XC/components/home/DownloadCenter.component?vue&type=script&lang=js&"
export * from "XC/components/home/DownloadCenter.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports